export default __webpack_public_path__ + "static/media/user-delegate.2b9025ca.svg";